export const ISSUE_MAKER = "ISSUE_MAKER";
export const GET_PENDING_ORDERS = "GET_PENDING_ORDERS";
export const DEPART_COURIER = "DEPART_COURIER";
